export const AUTH_ENDPOINTS = {
  LOGIN: '/auth/login',
  TWO_FACTOR: '/auth/two-factor-challenge',
  REFRESH: '/auth/refresh',
  ME: '/auth/me',
  LOGOUT: '/auth/logout',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password',
  SETUP_PASSWORD: '/auth/setup-password',
} as const
